module.exports = __webpack_public_path__ + "static/media/fr_miller_lite.1a32b134.png";